export const config = {
  ad: {
    singlePack: {
      param: 'ad',
    }
  }
}

